import { render, staticRenderFns } from "./RiskAssessmentStddoc.vue?vue&type=template&id=5e8262ad&scoped=true&"
import script from "./RiskAssessmentStddoc.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentStddoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8262ad",
  null
  
)

export default component.exports